module.exports = __webpack_public_path__ + "img/APPR_RED.6af29cc6.svg";